module.exports = __webpack_public_path__ + "img/stock-3.dfd71feb.jpg";